import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { DATA } from "b2b/api/paths";
import { Uzivatel } from "b2b/renderers/ciselnik/";

import useMessages from "./i18n/useMessages";

export function ACZakaznikUzivatele({ zakaznikICO, ...props }) {
  const { uzivateleLabel, uzivatelePlaceholder } = useMessages();

  return (
    <Field
      component={Inputs.AutoComplete}
      url={DATA.uzivatele(zakaznikICO)}
      rendererSelected={Uzivatel}
      rendererOption={Uzivatel}
      loadOnce
      staticKey={["prijmeni", "jmeno"]}
      minChars={0}
      label={uzivateleLabel()}
      placeholder={uzivatelePlaceholder()}
      descriptionRenderer={Uzivatel}
      {...props}
    />
  );
}

ACZakaznikUzivatele.propTypes = {
  zakaznikICO: T.string,
  multiple: T.bool
};

export default React.memo(ACZakaznikUzivatele);
